import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AuthService } from '../../services/authService';
import { UserMessageService } from '../../services/userMessageService';
import { AccountAPI } from '../../services/accountAPI';

@inject(AuthService, Router, AccountAPI, UserMessageService)
export class Logo {
  constructor(authService, router, api, userMessageService) {

    this.authService = authService;
    this.router = router;
    this.api = api;
    this.userMessageService = userMessageService;

    this.saving = false;

    this.whitelabel = window.whitelabel || false;
  }

  activate() {
    this.clearForm();
    this.defaultBusinessType = 'Select...';
    this.api.getBusinessTypeList((list) => {
      this.businessTypeList = list;
      this.setData();
    }, this.saveLoadError.bind(this));
  }

  save() {

    if (this.validate()) {

      this.saving = true;
      this.api.save(
        this.getData(),
        (this.logo_files && this.logo_files.length > 0 ? this.logo_files[0] : null),
        this.authService.getUser().token,
        this.saveLoadSuccess.bind(this),
        this.saveLoadError.bind(this));
    }
  }


   getCookie(name) {
    const value = "; " + document.cookie;
    const parts = value.split("; " + name + "=");

    if (parts.length == 2) {
        return parts.pop().split(";").shift();
    }
  }

  getData() {
    var data = {
      ...this.authService.getAccount(),
      'org_name': this.orgName,
      'org_email': this.orgEmail,
      'org_phone': this.orgPhone,
      'website': this.website,
      'business_type': this.businessType.display_value,
      'business_type_detail': this.businessType.use_detail ? this.businessTypeDetail : null,

    };


    if(this.getCookie('_fprom_ref') && this.getCookie('_fprom_tid')){
      data.fp_prom_id=this.getCookie('_fprom_ref');
      data.fp_camp_id=this.getCookie('_fprom_tid')
    }

    return data;
  }

  setData() {
    let account = this.authService.getAccount();
    this.orgName = account.org_name;
    this.orgEmail = account.org_email;
    this.orgPhone = account.org_phone;
    this.website = account.website;

    this.defaultBusinessType = account.business_type;
    this.businessTypeDetail = account.business_type_detail;
    this.businessType = this.findBusinessType(this.defaultBusinessType);
    console.log(this.businessTypeDetail, this.businessType);

    $('.dashboard').css('background', '#fff');
  }

  clearForm() {

    this.orgName = null;
    this.orgEmail = null;
    this.orgPhone = null;
    this.website = null;
    this.businessType = null;
    this.businessTypeDetail = null;

  }

  saveLoadSuccess(account) {
    this.authService.setAccount(account);
    this.saving = false;
    this.router.navigate('home');
  }

  saveLoadError(msg) {
    this.userMessageService.setUserError("user", msg);
    this.saving = false;

  }

  findBusinessType(display_value) {
    for (var i = 0; i < this.businessTypeList.length; i++) {
      if (this.businessTypeList[i].display_value === display_value) {
        return this.businessTypeList[i];
      }
    }

    return;
  }

  businessTypeComparer(bt1, bt2) {
    if (bt1 && bt2) {
      return bt1.display_value === bt2.display_value;
    }

    return false;
  }

  validate() {

    var pass = true;




    if (this.orgName === null || this.orgName.trim() == '') {
      this.userMessageService.setUserError('user', 'Organization Name is empty');
      pass = false;
    }


    if (this.orgEmail === null || this.orgEmail.trim() == '') {
      this.userMessageService.setUserError('user', 'Organization Contact Email is empty');
      pass = false;
    }


    if (this.orgPhone === null || this.orgPhone.trim() == '') {
      this.userMessageService.setUserError('user', 'Organization Contact Phone is empty');
      pass = false;
    }

    if (this.website === null || this.website.trim() == '') {
      this.userMessageService.setUserError('user', 'Organization Web Address is empty');
      pass = false;
    }


    if (this.businessType == "Select...") {
      this.userMessageService.setUserError('user', 'Please select an Organization Type');
      pass = false;
    } else {
      if (this.businessType.use_detail) {
        if (this.businessTypeDetail === null || this.businessTypeDetail.trim() == '') {
          this.userMessageService.setUserError('user', 'Please enter Type of Organization');
          pass = false;
        }
      }
    }

    if (this.logo_files == null || this.logo_files.length == 0) {

      this.userMessageService.setUserError("user", "No Logo file selected");
      pass = false;

    }

    return pass;

  }



}
